import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useRutasStore = defineStore('rutas', () => {
  // console.log("Location.pathname", document.location.pathname
  const list = ref([])

  const setRutas = (data) => {
    list.value = data
  }

  return {
    list,
    setRutas
  }
},
  {
    persist: {
      key: 'rutas',
      storage: localStorage,
      debug: true,
      paths: [
        'list',
      ]
    }
  })
